<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <div class="space-y-8">
      <!-- Seção: Dados da Empresa -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Dados da empresa'"
            :Sessao="'Dados Cadastrais'"
            :SubSessao="'Dados da Empresa'"
          />
        </div>
        <div class="form-section-content">
          <div class="form-grid-12">
            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="razaoSocial"
                >Razão social</label
              >
              <input
                class="field"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.RazaoSocial"
                type="text"
                id="razaoSocial"
                disabled="true"
                placeholder="Empresa X LTDA"
              />
            </div>
            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="cnpj"
                >CNPJ</label
              >
              <input
                class="field"
                type="text"
                id="cnpj"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Cnpj"
                disabled="true"
                placeholder="AA.AAA.AAA/AAAA-00"
              />
            </div>
            <div
              v-if="configuracaoApelido == 'S'"
              class="col-span-4 form-field"
            >
              <div class="flex items-center gap-2">
                <label
                  class="form-field-label form-field-label-required"
                  for="apelido"
                  >Apelido</label
                >
                <i
                  class="fa fa-info-circle form-helper-icon"
                  title="O apelido deve ter entre 3 e 20 caracteres, podendo incluir letras (maiúsculas ou minúsculas) e números. Não é permitido o uso de caracteres especiais."
                ></i>
              </div>
              <input
                class="field"
                type="text"
                id="apelido"
                v-model="localFI.Apelido"
                @input="validarApelido"
                @blur="checkApelidoLength"
                @change="salvarAlteracoesLocalmente"
              />
              <p v-if="apelidoError" class="form-field-error">
                {{ apelidoError }}
              </p>
              <p v-if="camposObrigatorios.erroApelido" class="form-field-error">
                Campo obrigatório
              </p>
            </div>
            <div
              v-if="
                configuracaoAssessores === 'S' &&
                modoPreenchimentoAssessor === '2'
              "
              class="col-span-4 form-field"
            >
              <label class="form-field-label" for="assessor">{{
                nomeCampoAssessor
              }}</label>
              <div class="relative">
                <div class="relative">
                  <input
                    type="text"
                    v-model="assessorBusca"
                    @input="buscarAssessores(assessorBusca)"
                    @blur="fecharDropdownAssessor"
                    :placeholder="`Selecione o ${nomeCampoAssessor}`"
                    autocomplete="off"
                    class="field"
                    :class="{ 'pr-8': assessorSelecionadoNome }"
                  />
                  <button
                    v-if="assessorSelecionadoNome"
                    type="button"
                    @mousedown.prevent="limparAssessor"
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 text-lg leading-none"
                    title="Limpar"
                  >
                    ×
                  </button>
                  <span
                    v-if="assessorBuscando"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"
                    >...</span
                  >
                </div>
                <ul
                  v-if="assessorDropdownAberto && listaAssessores.length > 0"
                  class="assessor-dropdown"
                >
                  <li
                    v-for="assessor in listaAssessores"
                    :key="assessor.IdExterno"
                    @mousedown.prevent="selecionarAssessor(assessor)"
                    class="assessor-dropdown-item"
                  >
                    <span class="font-medium">{{ assessor.Nome }}</span>
                    <span
                      v-if="assessor.Categoria"
                      class="text-xs opacity-60 ml-2"
                      >{{ assessor.Categoria }}</span
                    >
                  </li>
                </ul>
                <p
                  v-if="
                    assessorDropdownAberto &&
                    !assessorBuscando &&
                    listaAssessores.length === 0 &&
                    assessorBusca.length >= 3
                  "
                  class="text-xs text-gray-500 mt-1"
                >
                  Nenhum {{ nomeCampoAssessor }} encontrado.
                </p>
              </div>
            </div>
          </div>
          <div class="form-grid-12">
            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="RamoAtividade"
                >Ramo de atividade</label
              >
              <ModalSelect
                id="atividadePrincipal"
                @change="salvarAlteracoesLocalmente"
                class="field"
                v-model="localFI.RamoAtividade"
                :options="listaAtividades || []" value-key="id" label-key="descricao"
                title="Ramo de atividade" placeholder="Selecione" required
              />
              <p
                v-if="camposObrigatorios.erroRamoAtividade"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>

            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="tipoInvestidor"
                >Natureza Jurídica</label
              >
              <ModalSelect
                id="tipoInvestidor"
                :disabled="localFI.NaturezaJuridicaDataSincronizacao != null"
                @change="salvarAlteracoesLocalmente"
                class="field"
                v-model="localFI.NaturezaJuridicaId"
                :options="listaNaturezaJuridica || []" value-key="Codigo" :custom-label="item => item.Codigo + ' - ' + item.Descricao"
                title="Natureza Jurídica" placeholder="Selecione" required
              />
              <p
                v-if="camposObrigatorios.erroNaturezaJuridica"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>

            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="dataConstituicao"
                >Data de constituição</label
              >
              <input
                class="field"
                disabled="true"
                type="field"
                id="dataConstituicao"
                v-model="localFI.DataConstituicaoFormatada"
                placeholder="00/00/0000"
              />
            </div>
          </div>
          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label" for="pessoaContato"
                >Pessoa Contato</label
              >
              <input
                class="field"
                type="text"
                id="pessoaContato"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.PessoaContato"
              />
            </div>
            <div class="form-field">
              <label class="form-field-label" for="cargo">Cargo</label>
              <input
                class="field"
                type="text"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Cargo"
                id="cargo"
              />
            </div>
          </div>
          <div class="form-grid-3">
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="tipoFundo"
                >Tipo de Fundo</label
              >
              <ModalSelect
                class="field"
                id="tipoFundo"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.TipoFundo"
                :options="[{ Descricao: '' }, ...(listaTipoFundo || [])]" value-key="Descricao"
                :custom-label="item => item.Descricao === '' ? 'Selecione' : item.Descricao"
                title="Tipo de Fundo" placeholder="Selecione" required
              />
              <p
                v-if="camposObrigatorios.erroTipoFundo"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Regime de Constituição</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="Aberto"
                    name="regimeConstituicao"
                    class="form-radio-input"
                    v-model="localFI.RegimeConstituicao"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Aberto</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="Fechado"
                    name="regimeConstituicao"
                    class="form-radio-input"
                    v-model="localFI.RegimeConstituicao"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Fechado</span>
                </label>
              </div>
              <p
                v-if="camposObrigatorios.erroRegimeConstituicao"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Fundo Exclusivo</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    :value="true"
                    name="fundoExclusivo"
                    class="form-radio-input"
                    v-model="localFI.FundoExclusivo"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    :value="false"
                    name="fundoExclusivo"
                    class="form-radio-input"
                    v-model="localFI.FundoExclusivo"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
              </div>
              <p
                v-if="camposObrigatorios.erroFundoExclusivo"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
          </div>
          <div class="form-grid-12">
            <div class="col-span-3 form-field">
              <telefone-internacional
                v-if="inicializado"
                v-model="localFI.Telefone"
                label="Telefone"
                :name="'Telefone'"
                @validate="onValidateTelefone"
                @change="salvarAlteracoesLocalmente"
              />
              <p
                v-if="camposObrigatorios.erroTelefone && !localFI.Telefone"
                class="form-field-error"
              >
                Telefone obrigatório ou inválido
              </p>
            </div>

            <div class="col-span-3 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="Email"
                >E-mail</label
              >
              <input
                class="field"
                type="text"
                @blur="validarEmail"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Email"
                id="Email"
              />
              <p v-if="emailErros.Email" class="form-field-error">
                {{ emailErros.Email }}
              </p>
            </div>

            <div class="col-span-4 form-field">
              <div class="flex items-center gap-2">
                <label class="form-field-label form-field-label-required"
                  >Organização sem fins lucrativos?</label
                >
                <i
                  class="fa fa-info-circle form-helper-icon"
                  title="Marque 'Sim' se a empresa for uma associação, fundação, ONG ou entidade sem fins lucrativos."
                ></i>
              </div>
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="false"
                    :name="`SemFinsLucrativos_${index}`"
                    class="form-radio-input"
                    v-model="localFI.SemFinsLucrativos"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="true"
                    :name="`SemFinsLucrativos_${index}`"
                    class="form-radio-input"
                    v-model="localFI.SemFinsLucrativos"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Seção: Endereço Comercial -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Endereço comercial'"
            :Sessao="'Dados Cadastrais'"
            :SubSessao="'Endereço Comercial'"
          />
        </div>
        <div class="form-section-content">
          <EnderecoFields
            ref="commercialAddress"
            v-model="localFI"
            :countries="listaPaises"
            :field-map="commercialAddressFieldMap"
            id-prefix="fi-commercial-address"
            @change="salvarAlteracoesLocalmente"
          />
          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Emitir Extrato em Papel</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="true"
                    name="EmitirExtratoPapel"
                    class="form-radio-input"
                    v-model="localFI.EmitirExtratoPapel"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="false"
                    name="EmitirExtratoPapel"
                    class="form-radio-input"
                    v-model="localFI.EmitirExtratoPapel"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
              </div>
            </div>
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Esse endereço é o mesmo da correspondência?</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="1"
                    name="EnderecoCorrespondencia"
                    class="form-radio-input"
                    v-model="localFI.EnderecoCorrespondencia"
                    @change="limparCamposEnderecoCorrespondencia"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="2"
                    name="EnderecoCorrespondencia"
                    class="form-radio-input"
                    v-model="localFI.EnderecoCorrespondencia"
                    @change="limparCamposEnderecoCorrespondencia"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Seção: Endereço Correspondência (Condicional) -->
      <section v-if="localFI.EnderecoCorrespondencia == 2" class="form-section">
        <div class="form-section-header">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Endereço correspondência
          </h3>
        </div>
        <div class="form-section-content">
          <EnderecoFields
            ref="correspondenceAddress"
            v-model="localFI"
            :countries="listaPaises"
            :field-map="correspondenceAddressFieldMap"
            id-prefix="fi-correspondence-address"
            @change="salvarAlteracoesLocalmente"
          />
        </div>
      </section>
    </div>
    <ModalAlerta
      :mostrar="modalAlerta.mostrar"
      :tipo="modalAlerta.tipo"
      :titulo="modalAlerta.titulo"
      :mensagem="modalAlerta.mensagem"
      @fechar="modalAlerta.mostrar = false"
    />
  </div>
</template>

<script>
import ModalSelect from "@/components/ModalSelect.vue";
import { mapGetters, mapActions } from "vuex";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import EnderecoFields from "@/components/EnderecoFields.vue";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
import api from "@/api/axios";
export default {
  name: "CadastroOutros_DadosEmpresa",
  props: ["Edicao"],
  mixins: [emailValidatorMixin],
  components: { ModalSelect, LabelDisclaimer, ModalAlerta, EnderecoFields },
  computed: {
    ...mapGetters({
      user: "auth/user",
      infoEmpresa: "GET_FI_INFO_EMPRESA",
      listaAtividades: "GET_LISTA_ATIVIDADES",
      configuracoes: "GET_CONFIGURACAO",
      listaPaises: "GET_LISTA_PAISES",
      listaNaturezaJuridica: "GET_LISTA_NATUREZA_JURIDICA",
      listaTipoFundo: "GET_LISTA_TIPO_FUNDO",
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
  },
  data() {
    return {
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      emailErros: {},
      telefoneValido: [],
      commercialAddressFieldMap: {
        number: "LogradouroNumero",
        complement: "LogradouroComplemento",
      },
      correspondenceAddressFieldMap: {
        postalCode: "CepOutro",
        street: "LogradouroOutro",
        number: "LogradouroNumeroOutro",
        complement: "LogradouroComplementoOutro",
        neighborhood: "BairroOutro",
        city: "CidadeOutro",
        region: "UfOutro",
        country: "PaisOutro",
      },
      camposObrigatorios: {
        erroEnderecoCep: false,
        erroEnderecoLogradouro: false,
        erroEnderecoNumero: false,
        erroEnderecoBairro: false,
        erroEnderecoCidade: false,
        erroEnderecoUf: false,
        erroNaturezaJuridica: false,
        erroEnderecoPais: false,
        erroEnderecoOutroCep: false,
        erroEnderecoOutroLogradouro: false,
        erroEnderecoOutroNumero: false,
        erroEnderecoOutroBairro: false,
        erroEnderecoOutroCidade: false,
        erroEnderecoOutroUf: false,
        erroEnderecoOutroPais: false,
        erroRegimeConstituicao: false,
        erroFundoExclusivo: false,
        erroTipoFundo: false,
      },
      configuracaoAssessores: "",
      modoPreenchimentoAssessor: "",
      assessorBusca: "",
      assessorSelecionadoNome: "",
      listaAssessores: [],
      assessorDropdownAberto: false,
      assessorBuscando: false,
      assessorBuscaTimer: null,
      nomeCampoAssessor: "Assessor",
      permitirAvancar: false,
      localFI: {
        RazaoSocial: null,
        Cnpj: null,
        Apelido: null,
        RamoAtividade: null,
        DataConstituicao: null,
        PessoaContato: null,
        Cargo: null,
        Email: null,
        Telefone: null,
        SemFinsLucrativos: null,
        Logradouro: null,
        LogradouroNumero: null,
        LogradouroComplemento: null,
        NaturezaJuridicaId: null,
        NaturezaJuridicaDataSincronizacao: null,
        Bairro: null,
        Cidade: null,
        Uf: null,
        Pais: null,
        Cep: null,
        LogradouroOutro: null,
        LogradouroNumeroOutro: null,
        LogradouroComplementoOutro: null,
        BairroOutro: null,
        CidadeOutro: null,
        UfOutro: null,
        PaisOutro: null,
        CepOutro: null,
        EmitirExtratoPapel: false,
        EnderecoCorrespondencia: "1",
        RegimeConstituicao: null,
        FundoExclusivo: null,
        TipoFundo: null,
        AssessorId: null,
      },
      apelidoError: "",
      configuracaoApelido: "",
      inicializado: false,
    };
  },
  mounted() {
    this.localFI = this.infoEmpresa;
    if (this.infoEmpresa != null && this.infoEmpresa.DataConstituicao != null) {
      this.localFI.DataConstituicao = this.converterData(
        this.infoEmpresa.DataConstituicao,
      );
    }
    if (this.localFI != null) {
      this.localFI.EnderecoCorrespondencia =
        this.infoEmpresa.CepOutro != "" && this.infoEmpresa.CepOutro != null
          ? 2
          : 1;
    }
    this.inicializado = true;
    this.validarFormulario();
  },

  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    onValidateTelefone({ name, valid }) {
      if (!this.telefoneValido) {
        this.telefoneValido = {};
      }
      if (valid != "undefined") {
        this.telefoneValido[name] = valid;
      }
    },
    validarEmail() {
      this.validarEmailGeneric(this.localFI.Email, "Email", {
        obrigatorio: true,
      });
    },
    async buscarAssessores(termo) {
      clearTimeout(this.assessorBuscaTimer);
      this.localFI.AssessorId = null;
      this.assessorSelecionadoNome = "";
      if (!termo || termo.length < 3) {
        this.listaAssessores = [];
        this.assessorDropdownAberto = false;
        return;
      }
      this.assessorBuscaTimer = setTimeout(async () => {
        try {
          this.assessorBuscando = true;
          const res = await api.get(
            `/assessor?nomeAssessor=${encodeURIComponent(termo)}`,
          );
          this.listaAssessores = res.data || [];
          this.assessorDropdownAberto = true;
        } catch {
          this.listaAssessores = [];
        } finally {
          this.assessorBuscando = false;
        }
      }, 400);
    },
    selecionarAssessor(assessor) {
      this.localFI.AssessorId = assessor.IdExterno;
      this.assessorSelecionadoNome = assessor.Nome;
      this.assessorBusca = assessor.Nome;
      this.assessorDropdownAberto = false;
      this.listaAssessores = [];
      this.salvarAlteracoesLocalmente();
    },
    limparAssessor() {
      this.localFI.AssessorId = null;
      this.assessorSelecionadoNome = "";
      this.assessorBusca = "";
      this.listaAssessores = [];
      this.assessorDropdownAberto = false;
      this.salvarAlteracoesLocalmente();
    },
    fecharDropdownAssessor() {
      setTimeout(() => {
        this.assessorDropdownAberto = false;
      }, 150);
    },
    converterData(dataString) {
      if (dataString && dataString !== "0001-01-01T00:00:00") {
        let data = new Date(dataString);
        let ano = data.getFullYear();
        let mes = (data.getMonth() + 1).toString().padStart(2, "0");
        let dia = data.getDate().toString().padStart(2, "0");
        return `${ano}-${mes}-${dia}`;
      } else {
        return null;
      }
    },
    validarApelido(event) {
      if (this.configuracaoApelido === "S") {
        const value = event.target.value;
        const regex = /[^a-zA-Z0-9]/g;
        this.localFI.Apelido = value.replace(regex, "").slice(0, 20);
      }
    },
    checkApelidoLength(event) {
      if (!this.localFI.Apelido || this.localFI.Apelido.length < 3) {
        this.apelidoError =
          "O campo apelido deve ter no mínimo três caracteres.";
        event.target.focus();
      } else {
        this.apelidoError = "";
      }
    },
    proximaEtapa() {
      this.validarFormulario(true);
      if (this.permitirAvancar) {
        this.$store.commit("SET_ETAPA_CADASTRO", 1);
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.salvarInformacoes();
      }
    },
    validarFormulario(submeter) {
      this.permitirAvancar = true;
      var valorInvalido = false;

      var nomeDoCampo = "";
      this.camposObrigatorios = {
        erroEnderecoCep: false,
        erroEnderecoLogradouro: false,
        erroEnderecoNumero: false,
        erroEnderecoBairro: false,
        erroEnderecoCidade: false,
        erroEnderecoUf: false,
        erroEnderecoPais: false,
        erroEnderecoOutroCep: false,
        erroEnderecoOutroLogradouro: false,
        erroEnderecoOutroNumero: false,
        erroEnderecoOutroBairro: false,
        erroEnderecoOutroCidade: false,
        erroEnderecoOutroUf: false,
        erroEnderecoOutroPais: false,
        erroRegimeConstituicao: false,
        erroFundoExclusivo: false,
        erroTipoFundo: false,
      };
      if (!this.localFI.Apelido && this.configuracaoApelido === "S") {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroApelido = true;
          nomeDoCampo = "Apelido";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.RamoAtividade) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroRamoAtividade = true;
          nomeDoCampo = "Ramo da Atividade";
        }
        this.permitirAvancar = false;
      }

      if (!this.localFI.NaturezaJuridicaId) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroNaturezaJuridica = true;
          nomeDoCampo = "Natureza Jurídica";
        }
        this.permitirAvancar = false;
      }

      if (!this.localFI.RegimeConstituicao) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroRegimeConstituicao = true;
          nomeDoCampo = "Regime de Constituição";
        }
        this.permitirAvancar = false;
      }

      if (this.localFI.FundoExclusivo == null) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroFundoExclusivo = true;
          nomeDoCampo = "Fundo Exclusivo";
        }
        this.permitirAvancar = false;
      }

      if (!this.localFI.TipoFundo) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTipoFundo = true;
          nomeDoCampo = "Tipo de Fundo";
        }
        this.permitirAvancar = false;
      }

      if (!this.localFI.Telefone || this.telefoneValido.Telefone == false) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTelefone = true;
          nomeDoCampo = "Telefone";
        }
        if (this.telefoneValido.Telefone == false) {
          valorInvalido = true;
        }
        this.permitirAvancar = false;
      }

      if (Object.values(this.emailErros).some((erro) => erro !== "")) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEmail = true;
          nomeDoCampo = "E-mail";
        }
        this.permitirAvancar = false;
      }
      const commercialAddress = this.$refs.commercialAddress?.validate(Boolean(submeter));
      if (!commercialAddress?.valid) {
        if (submeter && this.permitirAvancar) {
          nomeDoCampo = `${commercialAddress?.firstInvalidLabel || "País"} do Endereço Comercial`;
        }
        this.permitirAvancar = false;
      }

      if (this.localFI.EnderecoCorrespondencia == 2) {
        const correspondenceAddress = this.$refs.correspondenceAddress?.validate(Boolean(submeter));
        if (!correspondenceAddress?.valid) {
          if (submeter && this.permitirAvancar) {
            nomeDoCampo = `${correspondenceAddress?.firstInvalidLabel || "País"} do Endereço de Correspondência`;
          }
          this.permitirAvancar = false;
        }
      }
      if (submeter && nomeDoCampo != "") {
        if (valorInvalido) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`,
          };
        } else {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} não foi informado ou é inválido, preencha a informação para avançar.`,
          };
        }
      }

      return this.permitirAvancar;
    },
    salvarInformacoes() {
      this.validarApelido({ target: { value: this.localFI.Apelido } });
      if (this.apelidoError) {
        return false;
      }
      this.$store.commit("SET_FI_SALVAR_INFO_BASICAS", this.localFI);
      this.$store.commit("SET_FI_SALVAR_INFO", true);
    },
    salvarAlteracoesLocalmente() {
      this.$store.commit("SET_FI_SALVAR_INFO_BASICAS", this.localFI);
      this.validarFormulario();
    },
    limparCamposEnderecoCorrespondencia() {
      this.localFI.LogradouroOutro = null;
      this.localFI.BairroOutro = null;
      this.localFI.CidadeOutro = null;
      this.localFI.UfOutro = null;
      this.localFI.PaisOutro = null;
      this.localFI.CepOutro = null;
      this.salvarAlteracoesLocalmente();
    },
  },
  async created() {
    await this.fetchConfiguracao([
      "EXIBIR APELIDO",
      "Assessores - Ativo",
      "Habilitar campo assessor",
      "Nome do Assessor",
    ]);
    this.configuracaoApelido =
      this.getConfiguracoes("EXIBIR APELIDO")?.Valor ?? "";
    this.configuracaoAssessores =
      this.getConfiguracoes("Assessores - Ativo")?.Valor ?? "";
    this.modoPreenchimentoAssessor =
      this.getConfiguracoes("Habilitar campo assessor")?.Valor ?? "";
    this.nomeCampoAssessor =
      this.getConfiguracoes("Nome do Assessor")?.Valor || "Assessor";
  },
  watch: {
    infoEmpresa() {
      this.localFI = this.infoEmpresa;
      if (
        this.infoEmpresa != null &&
        this.infoEmpresa.DataConstituicao != null
      ) {
        this.localFI.DataConstituicao = this.converterData(
          this.infoEmpresa.DataConstituicao,
        );
      }
      this.$nextTick(() => {
        this.$refs.commercialAddress?.refreshLookup();
        this.$refs.correspondenceAddress?.refreshLookup();
      });
    },
    configuracoes(newVal) {
      if (newVal && newVal.Valor) {
        this.configuracaoApelido = newVal.Valor;
      } else {
        console.error("Configurações não são válidas:", newVal);
        this.configuracaoApelido = [];
      }
    },
  },
};
</script>

<style scoped>
.assessor-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 50;
  margin-top: 2px;
  max-height: 220px;
  overflow-y: auto;
  border-radius: 0.25rem;
  background: white;
  border: 1px solid #d0d5dd;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  list-style: none;
  margin-left: 0;
  padding: 0.25rem 0;
}

.assessor-dropdown-item {
  padding: 0.6rem 0.875rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #344054;
  transition: background 0.15s;
  display: flex;
  align-items: baseline;
}

.assessor-dropdown-item:hover {
  background: #f2f4f7;
}
</style>

<!--<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');


.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
    border-bottom: 1px solid #D0D5DD;
    /* Borda */
}

.categoriaAgrupamentoFormulario {
    width: 10%;
    margin-right: 15px;

    h5 {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
    }

}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }




    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }


    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }

}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>-->
